<template lang="pug"></template>

<script>
export default {
    name: 'BotaoCertificacao',
    componentOptions: {
        title: 'certificacao',
        actions: [
            [
                {
                    name: 'Certificação',
                    iconClass: 'lyra-icon bunge-certificacao',
                    showView: false,
                    action: 'abrir',
                    route: 'Certificacao',
                    nameTranslationKey: 'mensagens.menuLateral.certificacao'
                }
            ]
        ]
    },

    methods: {
        abrirGestaoCertificacao() {
            if (this.$route.name !== 'Certificacao') {
                this.$router.push({ name: 'Certificacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
